export default __webpack_public_path__ + "static/media/icon-nav-open.68f5d1ef.svg";